import styled from "styled-components";

import { DATA_E2E_KEY, IStyledAttributes } from "@ryde/shared";
import { blueGreyMui, blueMui, deepPurpleMui, greyMui } from "@ryde/theme";

export const BulkPassengersMessageCountStyled = styled.div.attrs<IStyledAttributes>(
  {
    [DATA_E2E_KEY]: "bulk-passengers-message-count",
  },
)`
  display: flex;
  align-items: center;
  gap: 8px;
  font-weight: 600;
  font-size: 16px;
  margin-block: 12px;

  /* Dim while the rides participation filter is re-resolving the recipients. */
  &[aria-busy="true"] {
    opacity: 0.5;
  }

  span:nth-child(2) {
    color: ${blueMui._500};
  }
`;

export const BulkPassengersMessagePassengersListStyled = styled.div.attrs<IStyledAttributes>(
  {
    [DATA_E2E_KEY]: "bulk-passengers-message-list",
  },
)`
  display: flex;
  align-items: center;
  gap: 8px;

  /* Dim while the rides participation filter is re-resolving the recipients. */
  &[aria-busy="true"] {
    opacity: 0.5;
  }

  span:nth-child(2) {
    font-weight: 600;
    color: ${blueGreyMui._500};
  }
`;

export const RidesParticipationFilterStyled = styled.section.attrs<IStyledAttributes>(
  {
    [DATA_E2E_KEY]: "bulk-passengers-message-rides-participation-filter",
  },
)`
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px;
  margin-block: 16px;
  border: 1px solid ${greyMui._300};
  border-radius: 8px;

  .rides-participation-filter__icon {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    width: 40px;
    height: 40px;
    border: 1px solid ${greyMui._300};
    border-radius: 8px;
    color: ${deepPurpleMui._500};
  }

  /* Title and description are inline spans — without this they render on one run of text. */
  .rides-participation-filter__text {
    display: flex;
    flex-direction: column;
    flex: 1;
    min-width: 0;
  }

  .rides-participation-filter__title {
    font-weight: 600;
    color: ${deepPurpleMui._500};
    margin-block-end: 2px;
  }

  .rides-participation-filter__description {
    font-size: 12px;
    color: ${blueGreyMui._500};
  }

  .rides-participation-filter__field {
    flex-shrink: 0;
    width: 170px;
  }
`;

export const PassengersMessageAvailableTemplateStyled = styled.div.attrs<IStyledAttributes>(
  {
    [DATA_E2E_KEY]: "passengers-message-list-available-template",
  },
)`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;

  .item {
    font-weight: 600;
    color: ${blueGreyMui._500};
  }
`;
